import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { BindedView } from "../utilities";

export class ContentBridgePrototype extends HtmlBridgePrototype{

    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ContentHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}


class ContentHtmlBridge extends HtmlBridge{
    
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    
    private bindedView:BindedView;
    private prototype:ContentBridgePrototype;
    constructor(prototype:ContentBridgePrototype) {
        super();

        this.bindingPrototype = prototype.binding;
        this.prototype = prototype;
    }
    
    public set viewModel(v: ViewModel) { 
        if(this.bindedView.element){
            this.element.removeChild(this.bindedView.element);
        }
        
        this._viewModel = v;

        this.bindedView.update(this.viewModel);
        if(this.bindedView.element!=null)
            this.element.appendChild(this.bindedView.element);

    } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    

    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.bindedView = new BindedView(this.prototype.binding.getViewSelectorFunction(view));
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'viewModel'));
    }

    public release(){
        this.binding.release();
        this.bindedView.release();
    }
}